/**
 * The message to show a user when a Core request fails.
 *
 * Core answers a structured failure as `{ error, code }` (the ApiError envelope — used by
 * GlobalExceptionFilter for every unhandled exception, and by endpoints that return a specific
 * failure), while the ApiController helpers like `BadRequest("Text is required.")` answer
 * `{ message }`. The fetch hooks read only `message`, so every ApiError degraded to axios's own
 * "Request failed with status code 500" and the server's actual reason never reached the user —
 * which is how a 429 from the AI provider looked like the Generate button doing nothing at all.
 *
 * `error` is overloaded across Core: usually a human-readable message, but some endpoints put a
 * machine code there (`STORAGE_LIMIT_EXCEEDED` on a 413). A code shown in a toast is still more use
 * than a bare status number, so it is accepted — but only when it is actually a string, so an
 * endpoint answering `{ error: {...} }` cannot render as "[object Object]".
 */
export const getApiErrorMessage = (error) => {
  const data = error?.response?.data;

  const candidates = [data?.Message, data?.message, data?.error];
  const serverMessage = candidates.find((value) => typeof value === 'string' && value.trim() !== '');

  return serverMessage ?? error?.message;
};
